/** 实体商品 */
import React from 'react'
import { renderMoney, TimeStream } from '../../utils'
import PhysicalRefundDialog from './PhysicalRefundDialog'
import { ActionSheet } from 'react-weui'
import { WKInfiniteScroll } from '../../components/wk'
import { HTTPClient } from '@weike/toolkit'
import Config from '../../config'
import { toChatPage } from '../../services'
import '../../styles/record/RecordBuyListItem.css'
import { getPhysicalOrderCustomerUrl } from '../../services/common'
import { getWhiteList } from '../../api/module/gateway'
import { Dropdown } from '../../components/dropdown';
import { DropdownItem } from '../../components/dropdown/item';
const http = new HTTPClient({ baseURL: Config.CRM_API_URL }, '0000')
// 实体商品列表
export default class PhysicalGoods extends React.Component {
  constructor() {
    super()
    this.state = {
      listData: null,
      has_more: true,
      next_offset: 0,
      loading: false,
      ActionSheetShow: false,
      actions: [
        {
          label: '取消',
          onClick: this.handleSheetToggle.bind(this)
        }
      ],
      selectedItem: null,
      showPhysicalRefundDialog: false,
      
      serviceUrl: '',
      // 是否显示联系讲师
      isShowContactTeacher: false,
    }
  }

  componentDidMount() {
    this.fetchDataList()
  }

  fetchDataList() {
    return new Promise((resolve, reject) => {
      http
        .get('/mini_cms/v1/api/order.list_get', {
          params: {
            pay_state: 1,
            platform: 'wk',
            refund_state: -1,
            offset: this.state.next_offset,
            limit: 10
          }
        })
        .then((res) => {
          const { data_list, has_more, next_offset } = res.data
          const list = (this.state.listData || []).concat(data_list)
          this.setState({
            listData: list,
            next_offset,
            has_more
          })
          resolve()
        })
        .catch((err) => reject(err))
    })
  }

  handleLoadMore() {
    this.setState(
      {
        loading: true
      },
      async () => {
        try {
          await this.fetchDataList()
        } catch (err) {
          console.log(err)
        }
        this.setState({
          loading: false
        })
      }
    )
  }

  matchDeliverState = {
    init: "待发货",
    packed: "发货中", // 快递公司已揽件，此时还不一定能查到快递信息
    ing: "已发货",  // 已发货(快递公司运送中)
    end: "已签收",
    failed: "发货中" // 发货失败（展示给用户: 发货中）
  }

  handleSheetToggle() {
    this.setState({
      ActionSheetShow: !this.state.ActionSheetShow
    })
  }

  renderMenus() {
    const menu = [
      {
        label: '联系讲师',
        onClick: this.contactInstructor.bind(this),
        isShow: this.state.isShowContactTeacher
      },
      {
        label: '联系客服',
        onClick: () => {
          if (this.props.handleQrcodeShow) {
            this.props.handleQrcodeShow(this.state.selectedItem.outer_order_id)
          }
        }
      }
    ]
    // 实体商品待发货状态才可以申请退款 (用户没有填写收货地址就没有物流状态 this.state.selectedItem.delivery = {})
    if (
      this.state.selectedItem &&
      (this.state.selectedItem.delivery.state || 'init') === 'init' &&
      (this.state.selectedItem.refund_state === 0 || this.state.selectedItem.refund_state === 3)
    ) {
      menu.unshift({
        label: '申请退款',
        onClick: this.handlePhysicalDialogShow.bind(this)
      })
    }
    return menu.filter((item) => item.isShow !== false)
  }

  /** 联系讲师 */
  contactInstructor() {
    toChatPage(this.state.selectedItem.receiver_id)
  }

  /** 展示实体商品的退款弹窗 */
  handlePhysicalDialogShow() {
    this.handleSheetToggle()
    this.setState({
      showPhysicalRefundDialog: true
    })
  }

  /** 关闭实体商品的退款弹窗 */
  handlePhysicalDialogHide() {
    this.setState({
      showPhysicalRefundDialog: false
    })
  }

  handleAfterSales(item) {
    this.setState({
      selectedItem: item
    })
    this.handleSheetToggle()

    const liveroomId = ((item || {}).product || {}).src_org_id
    if (liveroomId) {
      getPhysicalOrderCustomerUrl(item.outer_order_id).then((url) => {
        this.setState({ serviceUrl: url })
      })
      getWhiteList(Number(liveroomId)).then(res => {
        this.setState({
          isShowContactTeacher: !res.is_pgc_liverooms
        })
      })
    } else {
      this.setState({
        serviceUrl: '',
        isShowContactTeacher: true,
      })
    }
  }

  /** 去退款详情页 */
  toRefundDetail(id) {
    location.assign(`${Config.MAIN_URL}/wk-mall/refund-detail/${id}`)
  }

  /** 提交申请退款 */
  handleRefundSubmit(val) {
    http
      .post('/mini_cms/v1/api/order.apply.refund.add', {
        order_id: this.state.selectedItem.id,
        platform: 'wk',
        reason: val
      })
      .then(() => {
        this.handlePhysicalDialogHide()
        window._wk_toast.show('申请退款成功，请耐心等待~', 'success', 2000)
        this.setState((prevState) => ({
          listData: prevState.listData.map((item) =>
            item.id === this.state.selectedItem.id
              ? { ...item, refund_state: 5 }
              : item
          )
        }))
      })
      .catch((err) => {
        this.handlePhysicalDialogHide()
        window._wk_toast.show(err && err.data && err.data.message, '', 2000)
      })
  }

  /** 确认收货 */
  handleSignFor(order_id) {
    http
      .post('/mini_cms/v1/api/delivery.confirm.edit', {
        order_id
      })
      .then(() => {
        window._wk_toast.show('确认收货成功~', 'success', 2000)
        this.setState((prevState) => ({
          listData: prevState.listData.map((item) =>
            item.id === order_id ? { ...item, delivery: { ...item.delivery, state: 'end' } } : item
          )
        }))
      })
      .catch((err) => {
        window._wk_toast.show(err && err.data && err.data.message, '', 2000)
      })
  }

  render() {
    const {
      listData,
      showPhysicalRefundDialog,
      actions,
      ActionSheetShow,
      loading,
      has_more
    } = this.state

    if (!listData) return null
    if (!listData.length) {
      return (
        <div className="physical-record-empty">
          <img
            className="empty-img"
            src={'https://static-cos.lycheer.net/xupload/20230918_empty.png'}
            alt=""
          />
          <div className="empty-text">暂无实物商品订单～</div>
        </div>
      )
    }
    return (
      <div className="physical-record-page">
        {listData.map((item) => {
          const getOrderId = item.id && `（ID：${item.id}）` || ''
          const skuTag = (() => {
            let result = []
            ;(item.spec || []).forEach(item => {
              result.push(...Object.values(item))
            })
            return result.join('/')
          })()

          return (
            <div className="record-page-container" key={item.id}>
              <div className="record-page-list-header">
                <span>订单类型：实体商品{getOrderId}</span>
                <span>购于：{TimeStream(item.pay_time, 'YMD')}</span>
              </div>
              <div className="weui-flex weui-padding record-buy-list-item">
                <div className="weui-flex__item flex_3">
                  <div
                    className="record-buy-list-item_img background-image"
                    style={{
                      backgroundImage: `url(${item.extra.product_info.cover})`
                    }}
                  />
                </div>
                <div className="weui-flex__item flex_9 padding-left record-buy-list-item-content">
                  <p className="record-buy-list-item_title record-buy-physical_title">
                    {item.extra.product_info.name}
                  </p>
                  <div>
                    <p className="record-buy-list-item_text vertical-center">
                      <span className="record-buy-list-item_price">
                        ¥{renderMoney(item.fee)}
                      </span>
                    </p>
                    <div className={"order-sku-tag"}>{skuTag}{skuTag ? '/' : ''}x{item.count}</div>
                    <div className={'order-status-block'}>
                      <div
                        className={`order-status order-status-${item.delivery.state || 'init'}`}>
                        {this.matchDeliverState[item.delivery.state || 'init']}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="weui-padding record-actions">
                <div className={'record-buy-list-item_topborder record-actions-left'}>
                  <Dropdown droplist={
                    <div>
                      <DropdownItem onClick={() => this.handleAfterSales(item)}>售后</DropdownItem>
                    </div>
                  }>
                    <div className={'record-buy-list-item-text-button'}>
                      更多
                    </div>
                  </Dropdown>
                </div>
                <div className={'record-buy-list-item_topborder record-actions-right'}>
                  {item.refund_state === 0 && item.delivery.state === 'ing' && (
                    <button
                      className="record-buy-list-item-button"
                      onClick={() => this.handleSignFor(item.id)}>
                      确认收货
                    </button>
                  )}
                  {item.refund_state === 0 && item.delivery.state === 'init' && (
                    <button
                      className="record-buy-list-item-button"
                      onClick={() => {
                        if (
                          !window.localStorage.getItem(
                            `physical_order_id_${item.id}`,
                          )
                        ) {
                          window._wk_toast.show('提醒发货成功~', 'success', 2000)
                          window.localStorage.setItem(
                            `physical_order_id_${item.id}`,
                            1,
                          )
                        } else {
                          window._wk_toast.show('请勿重复提醒~', '', 2000)
                        }
                      }}>
                      提醒发货
                    </button>
                  )}
                  {item.refund_state === 0 && ['packed', 'ing', 'failed', 'end'].includes(item.delivery.state) && (
                    <button
                      className="record-buy-list-item-button"
                      onClick={() =>
                        location.assign(
                          `${Config.MAIN_URL}/activity2/express?order_id=${item.id}&order_sys=cms`,
                        )
                      }>
                      查看物流
                    </button>
                  )}
                  {item.is_fill_delivery && item.refund_state === 0 && (
                    <button
                      className="record-buy-list-item-button record-buy-list-item-button-primary-2"
                      onClick={() =>
                        location.assign(
                          `${Config.MAIN_URL}/wk-mall/order-detail/${item.id}?action=write_address`,
                        )
                      }>
                      填写收货地址
                    </button>
                  )}
                  {item.refund_state === 5 && (
                    <button
                      className="record-buy-list-item-button"
                      onClick={() => this.toRefundDetail(item.id)}>
                      退款申请中
                    </button>
                  )}
                  {item.refund_state === 1 && (
                    <button
                      className="record-buy-list-item-button"
                      onClick={() => this.toRefundDetail(item.id)}>
                      退款中
                    </button>
                  )}
                  {(item.refund_state === 3 || item.last_refund_state === 3) && (
                    <button
                      className="record-buy-list-item-button"
                      onClick={() => this.toRefundDetail(item.id)}>
                      退款失败
                    </button>
                  )}
                  {item.refund_state === 2 && (
                    <button
                      className="record-buy-list-item-button"
                      onClick={() => this.toRefundDetail(item.id)}>
                      已退款
                    </button>
                  )}

                  <a
                    onClick={() =>
                      location.assign(
                        `${Config.MAIN_URL}/wk-mall/order-detail/${item.id}`,
                      )
                    }
                    className="record-buy-list-item-button record-buy-list-item-button-enter">
                    订单详情
                  </a>
                </div>
              </div>
            </div>
          )
        })}
        <div style={{ position: 'relative', zIndex: '100' }}>
          <ActionSheet
            menus={this.renderMenus()}
            actions={actions}
            show={ActionSheetShow}
            type="ios"
            onTouchStart={() => {}}
            onRequestClose={() => this.setState({ ActionSheetShow: false })}
          />
        </div>
        <WKInfiniteScroll
          onTouchBottom={() => this.handleLoadMore()} // 到达底部执行的方法
          isStop={loading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
          distance={200} // 距离底部多少px触发
          isKill={!has_more} // 不再监听滚动
        />
        {showPhysicalRefundDialog && (
          <PhysicalRefundDialog
            handlePhysicalDialogHide={() => this.handlePhysicalDialogHide()}
            handleRefundSubmit={(val) => this.handleRefundSubmit(val)}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/BoughtPage/PhysicalGoods.js